import { render, staticRenderFns } from "./ShiftToResources.vue?vue&type=template&id=907e7ece&lang=html&"
import script from "./ShiftToResources.vue?vue&type=script&lang=js&"
export * from "./ShiftToResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports